import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {TransactionLpResponse} from '../../models/transactionLpResponse.model';
import {DistributionTransactionPurpose} from '../../../shared/enums/DistributionTransactionPurpose.enum';
import {TransactionStatus} from '../../models/transactionStatus.enum';

@Component({
  selector: 'terra-lp-transaction-details-dialog',
  templateUrl: './lp-transaction-details-dialog.component.html',
  styleUrls: ['./lp-transaction-details-dialog.component.scss']
})
export class LpTransactionDetailsDialogComponent {
  // enums
  readonly distributionType = DistributionTransactionPurpose;
  readonly transactionStatus = TransactionStatus;

  isDistribution = !this.data.isOutgoing;
  feeAmount = this.data.orderDetails?.finalFee > 0 ? this.data.orderDetails.finalFee : this.data.orderDetails?.indicativeFee;
  receiveAmount = this.data.orderDetails?.finalCalculatedAmount > 0 ? this.data.orderDetails.finalCalculatedAmount : this.data.orderDetails?.indicativeCalculatedAmount;
  exchangeRate = this.data.orderDetails?.rateDisplay;
  inverseExchangeRate = this.data.orderDetails?.rateDisplayInverse;
  isMultiTypeDistribution = this.data.distributionType === this.distributionType.MultiType;

  get calculatedMarkup() {
    return this.data.orderDetails.markupPercent ? ((this.data.orderDetails.amount - this.feeAmount) / 100 * this.data.orderDetails.markupPercent) : 0;
  }

  constructor(public dialogRef: MatDialogRef<LpTransactionDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: TransactionLpResponse) {
  }

  // replaces \n with <br>
  public parseLineBreaks(str: string) {
    return str.replace(/\n/g, '<br>');
  }
}
